/* eslint-disable no-alert */
import { makeStyles } from '@mui/styles'
import { FunctionComponent, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  Button,
  CircularProgress,
  Divider,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useFormik } from 'formik'
import axios from 'axios'
import { always, compose } from 'ramda'
import TermsAndConditions from 'src/user/components/terms-and-conditions'
import theme from '../theme'
import validationSchema from '../authentication/validators/reset-password.validators'

let useStyles = makeStyles({
  root: {
    marginTop: '25vh',
  },
})

let RegisterUser: FunctionComponent = () => {
  let navigate = useNavigate()
  let [searchParams] = useSearchParams()
  let userEmail = searchParams.get('userEmail')
  let token = searchParams.get('token')
  let isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  let classes = useStyles()
  let [submitting, setSubmitting] = useState(false)

  let form = useFormik({
    validationSchema,
    initialValues: {
      userName: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
    },
    onSubmit: (values) => {
      setSubmitting(true)
      axios
        .post('/api/register-with-token', {
          password: values.password,
          confirmPassword: values.confirmPassword,
          userName: values.userName.trim(),
          firstName: values.firstName,
          lastName: values.lastName,
          userEmail,
          token,
        })
        .then(compose(alert, always('Account Created')))
        .then(() => setSubmitting(false))
        .then(compose(navigate, always<any>('/self-paced')))
        .catch((err) => {
          if (err.message.includes('400')) {
            window.alert('Username or email already exists.')
          } else if (err.message.includes('404')) {
            window.alert(
              'Token has expired. If you have received multiple emails to sign up, please use the most recent one.',
            )
          } else {
            window.alert(
              'Something went wrong with creating your account, please contact support@foamfrat.com.',
            )
          }
          setSubmitting(false)
        })
    },
  })
  return (
    <>
      <div className={`${classes.root} mx-auto ${isMobile ? 'w-3/4' : 'w-25'}`}>
        <div className="flex justify-center ">
          <Typography>REGISTRATION FORM</Typography>
        </div>
        <form className="flex flex-col" onSubmit={form.handleSubmit}>
          <TextField
            variant="standard"
            className="mx-2"
            label="Username"
            name="userName"
            type="text"
            onChange={form.handleChange}
            error={form.touched.userName && !!form.errors.userName}
            helperText={form.touched.userName && form.errors.userName}
          />

          <TextField
            variant="standard"
            className="mx-2"
            label="First Name"
            name="firstName"
            type="text"
            onChange={form.handleChange}
            error={form.touched.firstName && !!form.errors.firstName}
            helperText={form.touched.firstName && form.errors.firstName}
          />

          <TextField
            variant="standard"
            className="mx-2"
            label="Last Name"
            name="lastName"
            type="text"
            onChange={form.handleChange}
            error={form.touched.lastName && !!form.errors.lastName}
            helperText={form.touched.lastName && form.errors.lastName}
          />

          <TextField
            variant="standard"
            className="mx-2"
            label="Password"
            name="password"
            type="password"
            onChange={form.handleChange}
            error={form.touched.password && !!form.errors.password}
            helperText={form.touched.password && form.errors.password}
          />

          <TextField
            variant="standard"
            className="mx-2"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            onChange={form.handleChange}
            error={
              form.touched.confirmPassword && !!form.errors.confirmPassword
            }
            helperText={
              form.touched.confirmPassword && form.errors.confirmPassword
            }
          />

          <div className="flex justify-center">
            {submitting ? (
              <CircularProgress />
            ) : (
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="mt-4"
              >
                Create Account
              </Button>
            )}
          </div>
        </form>
        <Divider className="my-4" />
        <TermsAndConditions />
      </div>
    </>
  )
}

export default RegisterUser
